import React, { useEffect, useState, useContext, useRef } from 'react'
import { useDispatch } from 'react-redux'

import MapContext from './MapContext'
import HikerIcon from '../../icons/hiker.svg'
import CrossHairs from '../../icons/crosshairs.svg'

import { setSettings, useSettings } from '../../slices/settings'
import { useGeolocation, setHighAccuracy, GEOLOCATION_STATUS } from '../../slices/geolocation'
import { addMessage } from '../../slices/ui'
import { setMapView } from '../../slices/map'
import { OUT_OF_MAPS, WAITING_POSITION } from '../../trans'

const isAroundMapCenter = (map, position, tollerance) => {
  const centerPoint = map.project(map.getCenter())
  const positionPoint = map.project(position)
  const dx = centerPoint.x - positionPoint.x
  const dy = centerPoint.y - positionPoint.y
  return Math.max(Math.abs(dx), Math.abs(dy)) < tollerance 
}

const GeolocationControl = (props) => {
  const dispatch = useDispatch()
  const { geolocation } = useSettings()
  const { status, lnglat, error } = useGeolocation()
  const [isActive, setIsActive] = useState()
  const map = useContext(MapContext)
  const userLocation = useRef(null)
  const isLocated = status === GEOLOCATION_STATUS.FIXED
  const isOutOfMap = lnglat && map && !map.maxBounds.contains(lnglat)
  const followPosition = isActive && isLocated && !isOutOfMap

  useEffect(()=>{
    if (!followPosition || map.isMoving() || (!!userLocation.current && isAroundMapCenter(map, lnglat, 50))) return;
    dispatch(setMapView({lnglat: lnglat, zoom: !!userLocation.current ? map.getZoom() : 13}))
    userLocation.current = lnglat
  }, [map, followPosition, lnglat, dispatch])

  useEffect(()=>{
    if (!followPosition) return

    const stopMove = (e) => {
      if (!!userLocation.current && !isAroundMapCenter(map, userLocation.current, 150)) {
        userLocation.current = null
        setIsActive(false)
      }
    }

    map.on('moveend', stopMove)

    return () => {
      map.off('moveend', stopMove)
    }

  }, [map, followPosition])

  useEffect(()=>{
    if (isActive && status === GEOLOCATION_STATUS.WAITING){
      dispatch(addMessage({
        message:WAITING_POSITION,
        timeout: 3,
        status: 'info'
      }))
    }
    if (isActive && status === GEOLOCATION_STATUS.FIXED && isOutOfMap){
      dispatch(addMessage({
        message:OUT_OF_MAPS,
        timeout: 7,
        status: 'waring'
      }))
    }
  },[status, isActive, isOutOfMap])

  if (!navigator.geolocation) return null

  const toggleGeolocation = () => {
    if (isOutOfMap){
      dispatch(addMessage({
        message:OUT_OF_MAPS,
        timeout: 7,
        status: 'waring'
      }))
    } else {
      userLocation.current = null
      setIsActive(!isActive)
      if (!geolocation && !isActive){
        dispatch(setSettings({geolocation:true}))
      }
    }
  }

  const geolocationClassName = () => {
    let cls = ["button circular fa"]

    if ((geolocation && isOutOfMap)) {
      return cls + " basic disabled"
    }

    if (!geolocation) {
      return cls + " basic"
    }

    if (isActive){
      cls.push('secondary')
      switch (status){
        case GEOLOCATION_STATUS.WAITING:
          cls.push('pulse')
          break
        case GEOLOCATION_STATUS.FIXED:
          cls.push(isOutOfMap ? 'disabled' : 'active')
          break
      }
    } else {
      cls.push('basic')
    }
    
    return cls.join(' ')
  }

  return (
    <button className={geolocationClassName()}
      onClick={toggleGeolocation}>
      <CrossHairs/>
    </button>
  )
}

export default GeolocationControl
